import React from "react";
import Container from "@material-ui/core/Container";

const Footer = () => {
  return (
    <footer>
      <Container>
        <h3>
          <span role="img" aria-label="copyright">
            ©️
          </span>{" "}
          Made with{" "}
          <span role="img" aria-label="love">
            🥰
          </span>{" "}
          by{" "}
          <a
            href="https://arturmaiz.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Artur Maizelev
          </a>{" "}
          - 2020
        </h3>
      </Container>
    </footer>
  );
};

export default Footer;
